import type { Channel } from '../types';
import logger from './logger';

const LOCAL_PLAYLIST_KEY = 'iptv_player_local_playlist';

/**
 * Saves channels to localStorage for non-authenticated users
 */
export const saveChannelsLocally = (channels: Channel[]): void => {
  try {
    localStorage.setItem(LOCAL_PLAYLIST_KEY, JSON.stringify(channels));
    logger.debug('Channels saved to localStorage', { count: channels.length });
  } catch (error) {
    logger.error('Failed to save channels to localStorage', error);
  }
};

/**
 * Loads channels from localStorage for non-authenticated users
 */
export const loadChannelsLocally = (): Channel[] => {
  try {
    const storedChannels = localStorage.getItem(LOCAL_PLAYLIST_KEY);
    if (!storedChannels) {
      return [];
    }
    const channels = JSON.parse(storedChannels) as Channel[];
    logger.debug('Channels loaded from localStorage', { count: channels.length });
    return channels;
  } catch (error) {
    logger.error('Failed to load channels from localStorage', error);
    return [];
  }
};

/**
 * Removes channels from localStorage
 * Used when user logs in and we load from Firestore instead
 */
export const clearLocalChannels = (): void => {
  try {
    localStorage.removeItem(LOCAL_PLAYLIST_KEY);
    logger.debug('Local channels cleared from localStorage');
  } catch (error) {
    logger.error('Failed to clear channels from localStorage', error);
  }
}; 